const HUBSPOT_COOKIE_UTK = 'hubspotutk';
const HUBSPOT_COOKIE_HSTC = '__hstc';
const HUBSPOT_COOKIE_HSSC = '__hssc';
export const getCookie = key => {
  const cookies = document.cookie.match(`(^|[^;]+)\\s*${key}\\s*=\\s*([^;]+)`);
  return cookies ? cookies.pop() : '';
};
export const getUtk = () => getCookie(HUBSPOT_COOKIE_UTK);
export const getHSTC = () => getCookie(HUBSPOT_COOKIE_HSTC);
export const getHSSC = () => getCookie(HUBSPOT_COOKIE_HSSC);